// extracted by mini-css-extract-plugin
export default {"input":"FormulaireYScale_input__kjDwn","btnn":"FormulaireYScale_btnn__P7Nrb"};